// extracted by mini-css-extract-plugin
module.exports = {"tags":"Tags_tags__yJLCm","tag":"Tags_tag__8Ih1A","text":"Tags_text__MlHev"};